export default "__VITE_ASSET__CG3TdI5K__"